

import { DatepickerOptions } from 'ng2-datepicker';
import { Component, OnInit,ViewChild } from '@angular/core';
import { Router, ActivatedRoute,Params  } from '@angular/router';
import { FormBuilder, FormGroup, Validators,ReactiveFormsModule } from '@angular/forms';
import { first } from 'rxjs/operators';
import{NgForm} from '@angular/forms';
import {MatSnackBar} from '@angular/material';
//import { CommonService } from 'src/app/_services/common.service';
//common.service
import { Userdata, Plan } from './../../interface' 

import { CommonService } from './../../_services/common.service';



import {INgxMyDpOptions, IMyDateModel} from 'ngx-mydatepicker';


@Component({
  selector: 'app-planmasteraddedit',
  templateUrl: './planmasteraddedit.component.html',
  styleUrls: ['./planmasteraddedit.component.css']
})
export class PlanmasteraddeditComponent implements OnInit {
    model: any = {};
start_date=""
end_date=""
planimage=""
productLoading:Boolean=false
modelcatlogo:Boolean=false
//ngxdatepicker:any;
myOptions: INgxMyDpOptions = {
        dateFormat: 'dd-mm-yyyy',
       };
       dropdownSettingsorg={};
    ngxstartdate: any = {  
    jsdate: new Date() 
    };  
     
    ngxenddate: any = {  
    jsdate: new Date() 
    };

    plan_image:any
    plan: Plan =
    {
    utoken:localStorage.getItem("utoken"),
    usermasterid:localStorage.getItem("user_master_id"),
    planid: 0,
    planname: '',
    plandescription: '',
    planstartdate: '',
    planenddate: '',
    plantokencount: '',
    planamount:'',
    plancurrency:'INR',
    plancountryid:'101',
    plantype:'Pay As Use',
    plan_image:'',
    planstatus:'Active',
    Organisation:'',
    plan_image_path:''
   };
    loginForm: FormGroup;
    loading = false;
    submitted = false;
    returnUrl: string;
    error = '';
    role ='';
    massage="";
   file="";
   country:any;
inr="";
countrycod="";
date:any;
startdate:any;
enddate:any;
organisation:any;

plandeleteid:any


onFileChanged(event) 
{

    console.log("event",event.target.files[0].type)
    //fileInput.target.files[0].type
    if((event.target.files[0].type=="image/jpeg")||(event.target.files[0].type=="image/jpg")||(event.target.files[0].type=="image/png"))
    {

this.planimage=event.target.files[0]
    }
else
{
    this.snackbar.open("Invalid file type selected. Please select *.png, *.jpg, *.jpeg files.",'', {
        duration: 2000,
        verticalPosition:"top",
        extraClasses: ['bg-red']
    });

}

}

   
        errorMessage: string;
        deleteMessageEnabled: boolean;
        operationText = 'Insert';
        @ViewChild('customerForm') customerForm: NgForm;

    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private commonService:CommonService,
        private snackbar:MatSnackBar
       ) {}

    ngOnInit() {

        this.dropdownSettingsorg = {
            singleSelection: true,
            idField: 'org_id',
            textField: 'org_name',
            allowSearchFilter: true
        };



       
console.log("date",new Date())
this.route.params.subscribe(
params => {

if(this.route.snapshot.params.planid)
{
this.commonService.geteditplandata(this.route.snapshot.params.planid)
.subscribe(
 data => {

console.log("plandata",data)


this.plan_image=data.Data[0].plan_image

this.plandeleteid=data.Data[0].plan_id
    


this.plan.planid=data.Data[0].plan_id


console.log("data.Data[0].plan_id",this.plan.planid)
this.plan=data.Data[0]
this.plan.planname=data.Data[0].plan_name
this.plan.plandescription=data.Data[0].plan_description
this.plan.planstartdate=data.Data[0].plan_start_date
this.plan.planenddate=data.Data[0].plan_end_date
//str.split(',');
this.startdate=data.Data[0].plan_start_date.split('-');
this.enddate=data.Data[0].plan_end_date.split('-');
//console.log("end code",this.enddate[2])

this.ngxenddate= {  
    date: {  
        year: parseInt(this.enddate[2]),  
        month: parseInt(this.enddate[1]),  
        day: parseInt(this.enddate[0])  
    },
}

//ngxenddate

this.ngxstartdate= {  
    date: {  
        year: parseInt(this.startdate[2]),  
        month: parseInt(this.startdate[1]),  
        day: parseInt(this.startdate[0])  
    },
}



this.plan.plantokencount=data.Data[0].plan_token_count
this.plan.planamount=data.Data[0].plan_amount
this.plan.plancurrency=data.Data[0].plan_currency
this.plan.plancountryid=data.Data[0].plan_country_id
this.plan.plantype=data.Data[0].plan_type
this.plan.plan_image=data.Data[0].plan_image
this.plan.planstatus=data.Data[0].status
this.plan.plan_image_path=data.Data[0].plan_image_path


this.plan.Organisation=data.Data[0].parent_data

let currentUser = JSON.parse(localStorage.getItem('currentUser'));
this.plan.usermasterid=currentUser.user_master_id;
this.plan.utoken=currentUser.utoken;

this.getcountry()



})

//console.log("parame",this.route.snapshot.params.planid);
}
});
     
 //console.log("planaddeditcall","planaddeditcall");
let currentUser = JSON.parse(localStorage.getItem('currentUser'));
this.plan.usermasterid=currentUser.user_master_id;
this.plan.utoken=currentUser.utoken;
this.getcountry();
this.getOrganisation();
       
    }

    // convenience getter for easy access to form fields
    get f() { return this.loginForm.controls; }

    onSubmit() {
//console.log("plan.Organisation",this.plan)





//this.plan.Organisation

this.productLoading=true
if(this.start_date!="")
{
this.plan.planstartdate=this.start_date
}
if(this.end_date!="")
{
this.plan.planenddate=this.end_date     
}
if(this.planimage!="")
{
this.plan.plan_image_path=this.planimage
}
this.submitted = true;
if(this.plan.planid==0)
{

//var g =this.plan.Organisation[0]["org_id"]
//console.log("gggggg",g)


  //var   sdsdsd=g.toString
//  var s = sdsdsd["orgid"]


this.commonService.createplan(this.plan)
.subscribe(
data => {
if(data.status_code==200)
{
    this.productLoading=false
    this.snackbar.open(data.Metadata.Message, '', {
        duration: 2000,
         verticalPosition:"top",
        extraClasses: ['bg-green']
      }); 

this.router.navigate(['/plan']);
}
else
{
this.productLoading=false

this.snackbar.open(data.Metadata.Message, '', {
    duration: 2000,
     verticalPosition:"top",
    extraClasses: ['bg-red']
  }); 


}
})
}
else
{
console.log('enddate',this.plan.planenddate);
this.commonService.updateplan(this.plan)
.subscribe(
data => {
console.log("data",data);
if(data.status_code==200)
{

this.productLoading=false

    this.snackbar.open(data.Metadata.Message, '', {
        duration: 2000,
         verticalPosition:"top",
        extraClasses: ['bg-green']
      }); 


this.router.navigate(['/plan']);
}
else
{

    this.productLoading=false

//this.errorMessage=data.Metadata.Message
this.snackbar.open(data.Metadata.Message, '', {
    duration: 2000,
    verticalPosition:"top",
    extraClasses: ['bg-red']
  }); 

}
})
}
}



getOrganisation()
{
this.commonService.getOrganisation().subscribe(response=>{

console.log("getOrganisation",response.Data)

this.organisation=response.Data
//this.countrycod=response.Data.country_id
});
}

getcountry()
 {

this.commonService.getCountries().subscribe(response=>{
this.country=response.Data
this.countrycod=response.Data.country_id
  });
 

}

 onChange(val)
{

    console.log("on change",val)

for (var i = 0; i < this.country.length; i++)
{
if (this.country[i].country_id == val)
{
this.plan.plancurrency=this.country[i].currency_code;
}
}
}


onStartDateChanged(event: IMyDateModel): void {

if(event.formatted !== '') {
this.start_date=event.formatted
}
 
}

onEndDateChanged(event: IMyDateModel):void
{
if(event.formatted !== '') {
this.end_date=event.formatted
}
}








deleteplanlogo()
{
this.logofun("open")
}

logoconfirm()
{

//console.log("this.plan.planid",this.plandeleteid)


this.commonService.deleteplanlogo(this.plandeleteid).subscribe((response)=>{
if(response.status_code=="200")
{
this.logofun("cancel")

this.plan_image=""
this.plan.plan_image_path=""

//this.custom.org_logo=null
this.snackbar.open(response.Metadata.Message,'', {
        duration: 2000,
        verticalPosition:"top",
        extraClasses: ['bg-green']
    });
}
else
{
    this.snackbar.open(response.Metadata.Message,'', {
        duration: 2000,
        verticalPosition:"top",
        extraClasses: ['bg-red']
    });
}
})
}


logocancel()
{
    this.logofun("cancel")
}








logofun(action:string)
{

    if(action == "open"){
        this.modelcatlogo = true;
            }else{
                this.modelcatlogo = false;
                }

}









  
 }



// WEBPACK FOOTER //
// ./src/app/component/planmasteraddedit/planmasteraddedit.component.ts